import { StatementEditorV2ContentDataType, StatementEditorV2FieldDefinition } from '../types'
import { StatementV2 } from './StatementV2'
import { ContentBlockActions } from './ContentBlockActions'
import { RenderCellV2 } from '../../DataTableV2/RenderCellV2'

export function ItemColumnsLayoutV2({
  columnFields,
  content,
  serverActionsDisabled = false,
}: {
  columnFields: StatementEditorV2FieldDefinition[]
  content: StatementEditorV2ContentDataType
  serverActionsDisabled?: boolean
}) {
  const renderFieldValue = (field: StatementEditorV2FieldDefinition, data: StatementEditorV2ContentDataType) => {
    const value = data[field.propertyId]

    if (value === undefined || value === null) {
      return <div className="italic text-muted-foreground">No data</div>
    }

    if (Array.isArray(value) && field.fields && field.fields.length > 0) {
      const contentFields = field.fields.filter((f) => f.layout.position === 'content')
      const headerFields = field.fields.filter((f) => f.layout.position === 'header')
      return (
        <div className="flex flex-col gap-5">
          {value.map((item) => (
            <StatementV2
              parentId={content.id}
              key={(item as StatementEditorV2ContentDataType).id}
              item={item as StatementEditorV2ContentDataType}
              headerFields={headerFields}
              contentFields={contentFields}
              field={field}
              serverActionsDisabled={serverActionsDisabled}
            />
          ))}
        </div>
      )
    }

    if (field.layout.dataDisplay) {
      return <RenderCellV2 dataDisplay={field.layout.dataDisplay} value={value} />
    }

    return <span className="whitespace-pre-wrap">{String(value)}</span>
  }

  return (
    <>
      {columnFields.map((field) => {
        const { colStart, colSpan } = field.layout.columnLayout ?? {}
        const gridColumn = colStart != null && colSpan != null ? `${colStart} / span ${colSpan}` : undefined
        return (
          <div key={field.propertyId} style={{ gridColumn }} className="flex flex-col gap-y-3">
            <div className="flex items-center justify-between gap-x-2 border-b pb-1">
              <div className="font-semibold italic text-muted-foreground">{field.title}</div>
              {field.headerActions && field.headerActions.length > 0 ? (
                <div className="pr-3">
                  <ContentBlockActions
                    actions={field.headerActions}
                    formData={{ contentId: content.id }}
                    serverActionsDisabled={serverActionsDisabled}
                  />
                </div>
              ) : null}
            </div>
            <div className="overflow-hidden rounded-lg bg-offwhite p-5 shadow">{renderFieldValue(field, content)}</div>
          </div>
        )
      })}
    </>
  )
}
